import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

interface CountryEligibilityResponse {
  is_provided_country_eligible: boolean;
}

class SmsRegistryApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    this.baseApiClient = new BaseApiClient(`https://app${getEnv()}constantcontact.com/v1/sms_registrations/orgs/CTCT`);
  }

  public getSmsStatusSummary() {
    return this.baseApiClient.get<unknown>('/status_summary');
  }

  /**
   * Check if a country is eligible for SMS Marketing.
   *
   * The endpoint internally checks both the feature switch and country eligibility.
   * Control is managed by the SMS team via endpoint configuration.
   *
   * @param countryCode - ISO 3166-1 alpha-2 country code (e.g., "US", "AU")
   * @returns Promise resolving to { is_provided_country_eligible: boolean }
   *
   * See specs/sms-international.md
   */
  public getCountryEligibility(countryCode: string) {
    return this.baseApiClient.get<CountryEligibilityResponse>(`/country_eligibility/${countryCode}`);
  }
}

export const smsRegistryApi = new SmsRegistryApi();
